import { LangCode, LanguageCode } from '../common/api-response.model';
import { Pager } from '../common/pagination.model';

export interface AttributesResponse extends Pager {
  attributes: AttributeInfoResponse[];
  records?: AttributeInfoResponse[];
}

export interface OneAttributeResponse {
  slug?: string;
  attribute_key_translations?: any;
  attribute_key?: AttributeInfoResponse;
  attribute: AttributeInfoResponse;
  values?: AttributeValueInfoResponse[];
}

export interface AttributeInfoResponse {
  id: number;
  translations: {
    id: number;
    attribute_id: number;
    lang_code: LangCode;
    name: string;
    slug: string;
    date: Date;
  }[];
}

// Attribute Value
export interface AttributeValuesResponse extends Pager {
  values?: any;
  attribute_key?:any;
  attributeValue: AttributeValueInfoResponse[];
}

export interface OneAttributeValueResponse {
  slug: string;
  hex_color_code: string;
  translation?: any;
  attributeValue: AttributeValueInfoResponse;
}

export interface AttributeValueInfoResponse {
  id: number;
  attribute_id: number;
  translations: {
    lang_code: LangCode;
    value: string;
    additions: any;
  }[];
}

// Refactored

export interface PaginatedAttributeKeys extends Pager {
  records: AttributeKey[];
}

export interface AttributeKey {
  id: number;
  slug: string;
  translation: AttributeKeyTranslation;
  attribute_value_id_attribute_values: AttributeValue[];
}

export interface AttributeKeyTranslation {
  attribute_key_id: number;
  language: LanguageCode;
  name: string;
}

export interface PaginatedAttributeValues extends Pager {
  records: AttributeValue[];
}

export interface AttributeValue {
  id: number;
  slug: string;
  hex_color_code: string;
  translation: AttributeValueTranslation;
}

export interface AttributeValueTranslation {
  attribute_value_id: number;
  language: LanguageCode;
  name: string;
}
